import { useCallback } from 'react';
import { useRouter } from 'next/router';
import { TIME_FRAME_DROPDOWN_OPTIONS } from '../components/TimeFrameDropdown';

export default () => {
  const router = useRouter();

  /**
   * @description Pass in a timeframe to update the URL params & apply a date filter
   * @param timeFrameValue Must be a value from the TimeFrameDropdown options. Ex: 7 or '20230301'
   * @param shouldReplaceHistory
   */
  const updatePathWithTimeFrameDropdownValue = useCallback(
    ({ timeFrameValue, shouldReplaceHistory }: { timeFrameValue: string | number; shouldReplaceHistory: boolean }) => {
      if (typeof timeFrameValue === 'number') {
        delete router.query.startDate;
        router.query.daysBack = timeFrameValue.toString();
      } else {
        delete router.query.daysBack;
        router.query.startDate = timeFrameValue;
      }

      const updatedRouter = {
        pathname: router.pathname,
        query: router.query,
      };

      if (shouldReplaceHistory) {
        router.replace(updatedRouter);
      } else {
        router.push(updatedRouter);
      }
    },
    [router.query],
  );

  /**
   * @description Used when validating daysBack query param - checks if daysBack is a valid option in the TimeFrameDrodown options
   */
  const getIsDaysBackValid = useCallback((daysBack: number) => {
    return !!TIME_FRAME_DROPDOWN_OPTIONS.find((timeFrameFilter) => Number(timeFrameFilter.value) === daysBack);
  }, []);

  /**
   * @description Used when validating startDate query param - checks if startDate is a valid option in the TimeFrameDrodown options
   */
  const getIsStartDateValid = useCallback((startDate: string) => {
    return !!TIME_FRAME_DROPDOWN_OPTIONS.find((timeFrameFilter) => timeFrameFilter.value === startDate);
  }, []);

  return {
    getIsDaysBackValid,
    getIsStartDateValid,
    updatePathWithTimeFrameDropdownValue,
  };
};
